import MainLayout from "@/components/PatientLayout/MainLayout";
import { Card, notification, Table } from "antd";
import { useEffect, useState } from "react";
import { get } from "@/libs/axios";

const ClaimStatus = () => {
  const [tableLoading, setTableLoading] = useState(true);
  const [data, setData] = useState([])
  const [api, contextHolder] = notification.useNotification();
  const [enrollment, setEnrollment] = useState({})
  const [beginDate, setBeginDate] = useState('')

  useEffect(() => {
    loadEnrollment()
    loadData()
  }, []);

  const loadEnrollment = async () => {
    try {
      const { data } = await get('program_enrollments/detail');
      setEnrollment(data)
      setBeginDate(data.program_year && data.program_year["begin_date"])
    } catch (e) {
      console.error(e);
    }
  }

  const loadData = async () => {
    try {
      const { data } = await get('claims');
      setData(data);
    } catch (e) {
      console.error(e);
    } finally {
      setTableLoading(false)
    }
  }

  const hasEnrollment = !!Object.keys(enrollment).length
  return (
    <>
      {contextHolder}
      <Card className="mb-10">
        { hasEnrollment && (
          <>
            <div className="text-2xl font-bold">
              Current enrollment begin date
              {beginDate && <span className="text-xl text-zinc-500">&nbsp;({beginDate})</span>}
            </div>
            <div className="my-4 flex justify-between font-semibold">
              <span>ASSISTANCE RECEIVED: ${enrollment.total_amount_paid}</span>
              <span>ASSISTANCE REMAINING: ${enrollment.total_remaining}</span>
            </div>
          </>
        )}

        <Table
          loading={tableLoading}
          rowKey="id"
          bordered
          className="mt-4"
          dataSource={data} // This should be replaced with your data source
          columns={[
            {
              title: "Request Date",
              dataIndex: "created_at",
              key: "created_at"
            },
            {
              title: "Dispense Date",
              dataIndex: "date_of_service",
              key: "date_of_service",
            },
            {
              title: "Fill #",
              dataIndex: "fill_number",
              key: "fill_number",
            },
            {
              title: "Pharmacy Name",
              dataIndex: "pharmacy_name",
              key: "pharmacy_name",
              render: (_, record) => {
                if (record.pharmacy_name) {
                  return record.pharmacy_name
                } else {
                  return "Not Available"
                }
              }
            },
            {
              title: "Assistance Requested",
              dataIndex: "amount_requested",
              key: "amount_requested",
            },
            {
              title: "Assistance Provider",
              dataIndex: "total_amount_paid",
              key: "total_amount_paid",
            }
          ]}
        />
      </Card>
    </>
  )
}

export default ClaimStatus